import { Typography, styled } from "@mui/material";

const LessonPlanLabel = styled(Typography)(({ theme }) => ({
  fontSize: "12px",
  fontWeight: "700",
  lineHeight: "16px",
  color: theme.palette.text.disabled,
  textTransform: "uppercase",
  marginBottom: "4px",
}));

const LessonPlanValue = styled(Typography)(({ theme }) => ({
  fontSize: "14px",
  fontWeight: "500",
  lineHeight: "20px",
  color: theme.palette.text.primary,
}));

const FormHeading = styled(Typography)(({ theme }) => ({
  color: theme.palette.mode === "dark" ? "#e0e0e0" : "#333333",
  fontWeight: 300,
  fontSize: "18px",
  lineHeight: "24px",
  display: "block",
  textTransform: "capitalize",
}));

const FormSubHeading = styled(Typography)(({ theme }) => ({
  fontSize: "12px",
  marginBottom: "5px",
  textTransform: "uppercase",
  fontWeight: 600,
  color: theme.palette.text.secondary,
}));

export { LessonPlanLabel, LessonPlanValue, FormHeading, FormSubHeading };
